import(/* webpackMode: "eager" */ "/home/ubuntu/code/portofolio-front/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/code/portofolio-front/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/code/portofolio-front/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/code/portofolio-front/src/app/layout.module.css");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/code/portofolio-front/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/code/portofolio-front/src/components/AppBarComponent.tsx");
